module.exports = __webpack_public_path__ + "media/images/brand/unionpay-605146a07d29d2c94c1994f4a0207121.png";